module.exports = __webpack_public_path__ + "static/media/roundLogo.9132be52.svg";